import React, { useState } from 'react';
import './styles/venueOwnerNavBarStyles.css';
import AccountButton from '../userProfile/AccountButton';
import logo from '../../assets/happenings_logo.svg';
import { Box } from '@mui/material';

const logoStyle = {
    height: '30px',
    width: 'auto',
    cursor: 'pointer',
};

const VenueOwnerNavBar = () => {
    const [activeTab, setActiveTab] = useState('SERVICES');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                width: '100%',
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1200,
                bgcolor: 'white',
                padding: '8px 16px',
                height: '50px',
                borderBottom: '1px solid #e0e0e0',
            }}
        >
            <Box 
                className="logo-container" 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    width: '25%', 
                }}
            >
                <img src={logo} alt="Happenings Logo" style={logoStyle} />
            </Box>

            {/* Simple navigation tabs */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexGrow: 1,
                    width: '50%',
                }}
            >
                <Box sx={{ 
                    display: 'flex', 
                    gap: '30px',
                    justifyContent: 'center', 
                }}>
                    <Box 
                        onClick={() => handleTabClick('MY EVENTS')}
                        sx={{ 
                            padding: '4px 0', 
                            color: activeTab === 'MY EVENTS' ? '#3B82F6' : '#A0A0A0',
                            borderBottom: activeTab === 'MY EVENTS' ? '2px solid #3B82F6' : 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}
                    >
                        MY EVENTS
                    </Box>
                    <Box 
                        onClick={() => handleTabClick('SERVICES')}
                        sx={{ 
                            padding: '4px 0', 
                            color: activeTab === 'SERVICES' ? '#3B82F6' : '#A0A0A0',
                            borderBottom: activeTab === 'SERVICES' ? '2px solid #3B82F6' : 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}
                    >
                        SERVICES
                    </Box>
                    <Box 
                        onClick={() => handleTabClick('MESSAGES')}
                        sx={{ 
                            padding: '4px 0', 
                            color: activeTab === 'MESSAGES' ? '#3B82F6' : '#A0A0A0',
                            borderBottom: activeTab === 'MESSAGES' ? '2px solid #3B82F6' : 'none',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: 500,
                        }}
                    >
                        MESSAGES
                    </Box>
                </Box>
            </Box>

            <Box 
                className="hamburger-menu-container"
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    width: '25%',
                }}
            >
                <AccountButton 
                    onUserLogin={() => {}}
                    onUserLogout={() => {}}
                    userData={{}}
                />
            </Box>
        </Box>
    );
};

export default VenueOwnerNavBar;
